import React from 'react';
import logoSvg from '../assets/logo.png';

const Logo = ({ size = 100, className = '' }) => {
  return (
    <img
      src={logoSvg}
      width={size}
      height={size}
      alt="Symbolica Logo"
      className={className}
    />
  );
};

export default Logo; 